<template>
  <treeselect v-model="v" :multiple="true" :options="options" @input="$emit('input', v)"/>
</template>

<script>
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'OperatorPermissionSelector',
  components: {
    Treeselect,
  },
  props: ['value'],
  data() {
    return {
      v: this.value,
      options: [],
    }
  },
  mounted() {
    this.getModules();
  },
  watch: {
    value(newVal) {
      this.v = newVal;
    },
  },
  methods: {
    getModules() {
      this.$callAPI('permissions/', {}, function (response) {

        this.options = Object.keys(response.body.modules).map(function (k) {
          let module = response.body.modules[k];
          return {
            id: module.key,
            label: module.name,
            children: module.permissions.map(function (p) {
              return {id: module.key + "." + p.key, label: p.description}
            }),
            isDefaultExpanded: true,
          }
        });
      })
    },
  },
}
</script>
